import { WithStyles } from 'decorators/withStyles';
import React, { PureComponent } from 'react';

interface IProps {
  stepNumber?: string;
  title: string;
  component: string | any;
  classes?: any;
}

interface IState {}

@WithStyles(theme => ({
  stepContainer: {
    display: 'flex',
    flexFlow: 'wrap',
    justifyContent: 'space-between'
  },
  stepNumber: {
    alignItems: 'center',
    backgroundColor: '#F3F3F3',
    borderRadius: '50px',
    color: '#9B9B9B',
    display: 'flex',
    height: '51px',
    justifyContent: 'center',
    width: '51px'
  },
  containerText: {
    color: '#596375',
    marginLeft: '24px',
    width: '383px',
    '& p': {
      margin: 0
    }
  },
  title: {
    fontWeight: 'bold',
    fontSize: '18px',
    color: theme.variables.colors['primaryColor']
  }
}))
export default class StepDescription extends PureComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {};
  }

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.stepContainer}>
        <div className={classes.stepNumber}>{this.props.stepNumber}</div>
        <div className={classes.containerText}>
          <p className={classes.title}>{this.props.title}</p>
          {this.props.component}
        </div>
      </div>
    );
  }
}
